<template lang="pug">
.v-media-content.media-content(v-if="data" :style="{backgroundColor: data.backgroundColor}")
	.container
		.media-content__wrapper
			.media-content__title(v-if="data.title") {{data.title}}
			.media-content__text(v-if="data.text") {{data.text}}
			.media-content__inner(v-if="data.content || data.media")
				.media-content__content(v-if="data.content" :class="data.content.className")
					.media-content__content-title(v-if="data.content.title" v-html="data.content.title")
					.media-content__content-text(v-if="data.content.text") {{data.content.text}}
					.media-content__content-items(v-if="data.content.items && data.content.items")
						v-terms-box(v-for="term in data.content.items" :data-source="term")
					.media-content__content-announcement(v-if="data.content.announcement") {{data.content.announcement}}
					.media-content__content-description(v-if="data.content.description" v-html="data.content.description")
				.media-content__media(v-if="data.media" :class="data.content.className")
					img.media-content__media-image(v-if="data.media.image" :src="data.media.image.src" :alt="data.media.image.alt")
</template>

<script>

import sourceMixin from "components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
};
</script>